@let _contentComponent = contentComponent();
@let _contentTemplate  = contentTemplate();
@let _contentString    = contentString();

@if (_contentComponent) {
  <ng-container *ngComponentOutlet="_contentComponent"></ng-container>
}
@else if (_contentTemplate) {
  <ng-container *ngTemplateOutlet="_contentTemplate"></ng-container>
}
@else if (_contentString) {
  {{_contentString}}
}
